import React, { useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import ForgotPassword from './ForgotPassword';

export default function AuthModal({ isOpen, onClose, onLoginSuccess }) {
  const [view, setView] = useState('login'); // 'login', 'forgotPassword'
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Registration now lives on the dedicated /signup page.
  const switchToRegister = () => { onClose(); navigate('/signup'); };
  const switchToLogin = () => setView('login');
  const switchToForgotPassword = () => setView('forgotPassword');

  const handleSuccess = (authData) => {
    console.log('Auth successful:', authData);
    onLoginSuccess();
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={React.Fragment}>
      <Dialog 
        as="div" 
        className="relative z-10" 
        onClose={isLoading ? () => {} : onClose}
      >
        {/* Overlay */}
        <div className="fixed inset-0 bg-ink/40" />

        {/* Modal Panel */}
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white border border-sand p-6 text-left align-middle shadow-card transition-all">
                {/* Close Button */}
                <button
                  type="button"
                  className="absolute top-3 right-3 text-clay hover:text-ink transition-colors"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>

                {/* Conditional Rendering */}
                {view === 'login' && (
                  <Login
                    switchToRegister={switchToRegister}
                    switchToForgotPassword={switchToForgotPassword}
                    onSuccess={handleSuccess}
                    setIsLoading={setIsLoading}
                  />
                )}
                {view === 'forgotPassword' && (
                  <ForgotPassword 
                    switchToLogin={switchToLogin}
                    setIsLoading={setIsLoading}
                  />
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
